(function () {
    'use strict';

    angular.module('swif.parcauto')
    .config(route);

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/parcauto/contracts/table_view', {
            templateUrl: 'partials/patrimoine/contracts_table_view.html',
            controller: 'PatrimoineContractsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifParcautoService', function (service) {
                    return service.patrimoine.resolveContractsData();
                }]
            }
        });
        $routeProvider.when('/parcauto/referentiel/explorer_view', {
            templateUrl: 'partials/patrimoine/patrimoine_explorer_view.html',
            controller: 'PatrimoineReferentielController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifParcautoService', function (service) {
                    return service.patrimoine.resolveReferentielData();
                }]
            }
        });
        $routeProvider.when('/parcauto/referentiel/maps_view', {
            templateUrl: 'partials/patrimoine/patrimoine_maps_view.html',
            controller: 'PatrimoineReferentielController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifParcautoService', function (service) {
                    return service.patrimoine.resolveReferentielData();
                }]
            }
        });
    }

})();
